import { useContext, useEffect, useState } from 'react';
import clsx from 'clsx';
import * as R from 'ramda';

import DataTypeInput, {
  BooleanOrientation,
} from '@atom/components/common/dataTypeInput/DataTypeInput';
import { DataType } from '@atom/types/dataType';
import {
  AttributesType,
  HydratedAttributeGroupsItem,
} from '@atom/types/inventory';

import AttributeDetailsContext, {
  AttributeView,
} from './AttributeDetailsContext';
import { getAttributeValue } from './attributeDetailUtilities';

import classes from './attributeDetails.module.css';

interface Props {
  attribute: AttributesType;
  attributeGroup: HydratedAttributeGroupsItem;
}

const AttributeEditRow = ({ attribute, attributeGroup }: Props) => {
  const { onAttributeChange, errorAttributes, view, inputWidth } = useContext(
    AttributeDetailsContext,
  );

  const [value, setValue] = useState<any>(getAttributeValue(attribute, view));

  useEffect(() => {
    setValue(getAttributeValue(attribute, view));
  }, [attribute]);

  const onChange = (newValue: any) => {
    setValue(newValue);
    onAttributeChange(attribute.id, newValue);
  };

  const hasAttributeError = R.includes(
    attribute?.id,
    R.pathOr([], [attributeGroup.id], errorAttributes),
  );

  const nameStyles = () => {
    return clsx(
      classes.attributeLabel,
      classes.edit,
      view === AttributeView.MAP_TRAY && classes.tray,
      hasAttributeError && classes.error,
    );
  };
  const unitSuffix = ` (${attribute.unit})`;
  const attributeName = attribute.isRequired
    ? `* ${attribute.name}`
    : attribute.name;
  const widthStyle = inputWidth ? { width: inputWidth } : {};

  return (
    <div className={classes.attributeListRow}>
      <div className={nameStyles()}>
        {attributeName}
        {attribute.unit && !attribute.name.endsWith(unitSuffix) && unitSuffix}
      </div>
      <div className={classes.dataInputContainer} style={widthStyle}>
        <DataTypeInput
          id={attribute.id}
          dataType={attribute.dataType as DataType}
          options={attribute?.enumeration}
          thousandsSeparator={attribute?.thousandsSeparator}
          onChange={onChange}
          value={value}
          booleanOrientation={BooleanOrientation.HORIZONTAL}
          unit={attribute?.unit}
          disabled={!attribute?.isEditable}
          dataCyPrefix="attributeDetail"
        />
      </div>
    </div>
  );
};

export default AttributeEditRow;
